module.exports = __webpack_public_path__ + "static/media/pp.d9758196.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pp.jpg
// module id = 5747
// module chunks = 0